import { resilientQueryOptions } from 'constants/'
import { useQuery } from 'react-query'
import type { QueryOptions } from 'types'
import { logFactory } from 'utils'
import { useCoreConsentManagementService } from '../services'

interface Params {
  customerGid: string
}

const hookName = 'useCoreConsents'
const log = logFactory(hookName)

const useCoreConsents = (params: Params, options: QueryOptions = { enabled: true, refetchOnMount: false }) => {
  const { getConsents } = useCoreConsentManagementService()

  const fetchConsents = async () => {
    log(`📥 Fetching core consents...`, params)

    const consents = await getConsents(params)

    log(`☑️ Found ${consents.length} core consents`, consents)

    const granted = consents.filter((consent) => consent.granted)

    log(`✅ Narrowed down to the following ${granted.length} granted core consents`, granted)

    return granted
  }

  return useQuery([hookName, params], fetchConsents, {
    ...resilientQueryOptions,
    ...options,
    enabled: Boolean(params.customerGid && options?.enabled !== false),
  })
}

export { useCoreConsents }
